/*eslint-disable eqeqeq*/
import React, { Component } from "react";
import * as AppConstants from '../../../config/AppConstant';

class TabComponent extends Component {
	constructor() {
		super();
		this.state = {
			ActiveTab: 0
		};
	}

	render() {
		return (
			<div>
				<section style={{ marginTop: '20px' }}>
					<div className="tab-listing">
						<ul>
							{this.props.ChildrenTabs.map((item, index) => (
								<li>
									<a style={{ cursor: 'pointer' }} title="product details"
										className={`${this.props.INDEX == index && window.location.href.indexOf(item.PageURL) > 0 ? 'active' : ' '}`}
										onClick={() => {
											this.props.history.push({
												pathname: item.PageURL,
												state: { Index: index }
											})
										}}>{item.TabName}</a>
								</li>
							))}
						</ul>
					</div>
				</section>
			</div>
		);
	}
}

export default TabComponent;